import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_wrkrs_allowed_access_to_toiletsrestrooms_at_any_time'

export const dataPointDefinition = {
  retracedId: 'are_wrkrs_allowed_access_to_toiletsrestrooms_at_any_time',
  name: 'Are workers allowed access to toilets/restrooms at any time?',
  description:
    'The intent of this question is to understand if workers have access to toilets/restrooms. \r\r\n\r\r\nThis means that workers can seek out toilets/restrooms at any time. \r\r\n\r\r\nNote: Workers needing to ask for permission first is still considered "access", so long as access is granted.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-gen-10',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13630,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
